module.exports = __webpack_public_path__ + "img/Group12464@2x.1cbfd479.png";